module.exports = __webpack_public_path__ + "static/media/Poppins-Medium.28bc024a.ttf";